import { useDocumentScroll } from '../lib';
import { ApplyMiniRoad } from '../road';
import { useStyles } from './ApplyBootLoader.styles';

/**
 * The scooter while the flow's own code is still downloading.
 *
 * This is the route's Suspense fallback, so it stands in for the page rather than living
 * inside it: it fills the viewport, paints the stage colour, and declares the tokens the
 * scooter needs, all of which `ApplyStage` would otherwise provide.
 *
 * The candidate should meet the tenant's product, not Robin's spinner, on the very first
 * frame that has anything in it — which is why this is worth a component rather than
 * reusing the app-wide fallback.
 *
 * Purely decorative, and takes no copy: it renders before the page it stands in for, so
 * there is nothing to name it with that would not have to be threaded through the router.
 * The road is `aria-hidden`; the page announces itself when it arrives. `ApplyLoader` is
 * the labelled one, for waits that happen inside a page that is already up.
 */
export const ApplyBootLoader = () => {
  const classes = useStyles();

  // Claimed here as well as in the stage: this stands in for the page, so the document has
  // to scroll for it too, or the ground would change the moment the flow takes over.
  useDocumentScroll();

  return (
    <div css={classes.root}>
      <ApplyMiniRoad isPlaying />
    </div>
  );
};
